const minions = [
    {
        "Name": "Aureate Laureate",
        "Tier": "1",
        "Combined": "Pirate, Divine Shield",
        "ID": "BG32_236"
    },
    {
        "Name": "Bubble Gunner",
        "Tier": "1",
        "Combined": "Murloc, Battlecry",
        "ID": "BG31_149"
    },
    {
        "Name": "Buzzing Vermin",
        "Tier": "1",
        "Combined": "Beast, Deathrattle, Taunt",
        "ID": "BG31_803"
    },
    {
        "Name": "Cord Puller",
        "Tier": "1",
        "Combined": "Mech, Deathrattle, Divine Shield",
        "ID": "BG29_611"
    },
    {
        "Name": "Crackling Cyclone",
        "Tier": "1",
        "Combined": "Elemental, Divine Shield, Windfury",
        "ID": "BGS_119"
    },
    {
        "Name": "Dark Paradox",
        "Tier": "1",
        "Combined": "Beast, Demon, Dragon, Elemental, Mech, Murloc, Naga, Pirate, Quilboar, Undead",
        "ID": "BG36_360"
    },
    {
        "Name": "Dune Dweller",
        "Tier": "1",
        "Combined": "Elemental, Battlecry",
        "ID": "BG31_815"
    },
    {
        "Name": "Fleeing Fugitive",
        "Tier": "1",
        "Combined": "Naga",
        "ID": "BG36_921"
    },
    {
        "Name": "Flighty Scout",
        "Tier": "1",
        "Combined": "Murloc",
        "ID": "BG32_330"
    },
    {
        "Name": "Flittering Bat",
        "Tier": "1",
        "Combined": "Beast",
        "ID": "BG36_200"
    },
    {
        "Name": "Glim Guardian",
        "Tier": "1",
        "Combined": "Dragon",
        "ID": "BG29_888"
    },
    {
        "Name": "Harmless Bonehead",
        "Tier": "1",
        "Combined": "Undead, Deathrattle",
        "ID": "BG28_300"
    },
    {
        "Name": "Joyous",
        "Tier": "1",
        "Combined": "Battlecry",
        "ID": "BG36_110"
    },
    {
        "Name": "Lullabot",
        "Tier": "1",
        "Combined": "Mech",
        "ID": "BG26_146"
    },
    {
        "Name": "Mini-Myrmidon",
        "Tier": "1",
        "Combined": "Naga",
        "ID": "BG23_000"
    },
    {
        "Name": "Ominous Seer",
        "Tier": "1",
        "Combined": "Naga, Battlecry, Demon",
        "ID": "BG31_330"
    },
    {
        "Name": "Passenger",
        "Tier": "1",
        "Combined": "",
        "ID": "BGDUO_114"
    },
    {
        "Name": "Razorfen Geomancer",
        "Tier": "1",
        "Combined": "Quilboar, Battlecry",
        "ID": "BG20_100"
    },
    {
        "Name": "Risen Rider",
        "Tier": "1",
        "Combined": "Undead, Reborn, Taunt",
        "ID": "BG25_001"
    },
    {
        "Name": "Rot Hide Gnoll",
        "Tier": "1",
        "Combined": "Undead, Aura",
        "ID": "BG25_013"
    },
    {
        "Name": "Scarlet Survivor",
        "Tier": "1",
        "Combined": "Dragon, Divine Shield",
        "ID": "BG35_814"
    },
    {
        "Name": "Southsea Busker",
        "Tier": "1",
        "Combined": "Pirate, Battlecry",
        "ID": "BG26_135"
    },
    {
        "Name": "Suspicious Prisonguard",
        "Tier": "1",
        "Combined": "",
        "ID": "BG36_345"
    },
    {
        "Name": "Tusked Camper",
        "Tier": "1",
        "Combined": "Quilboar",
        "ID": "BG33_886"
    },
    {
        "Name": "Wrath Weaver",
        "Tier": "1",
        "Combined": "Demon",
        "ID": "BGS_004"
    },
    {
        "Name": "Zoatroid",
        "Tier": "1",
        "Combined": "Taunt",
        "ID": "BG36_098"
    },
    {
        "Name": "Bilgewater Breakout",
        "Tier": "2",
        "Combined": "Pirate, Battlecry",
        "ID": "BG36_520"
    },
    {
        "Name": "Blue Volumizer",
        "Tier": "2",
        "Combined": "Mech",
        "ID": "BG34_170t2"
    },
    {
        "Name": "Brain Rotter",
        "Tier": "2",
        "Combined": "",
        "ID": "BG36_099"
    },
    {
        "Name": "Bronze Warden",
        "Tier": "2",
        "Combined": "Dragon, Divine Shield, Reborn",
        "ID": "BGS_034"
    },
    {
        "Name": "Clever Castaway",
        "Tier": "2",
        "Combined": "Pirate, Discover",
        "ID": "BG36_342"
    },
    {
        "Name": "Crater Miner",
        "Tier": "2",
        "Combined": "Quilboar",
        "ID": "BG31_320"
    },
    {
        "Name": "Decoy Conjurer",
        "Tier": "2",
        "Combined": "",
        "ID": "BG36_354"
    },
    {
        "Name": "Electric Synthesizer",
        "Tier": "2",
        "Combined": "Dragon, Battlecry",
        "ID": "BG26_963"
    },
    {
        "Name": "Eternal Knight",
        "Tier": "2",
        "Combined": "Undead, Aura",
        "ID": "BG25_008"
    },
    {
        "Name": "Expert Aviator",
        "Tier": "2",
        "Combined": "Murloc",
        "ID": "BG34_140"
    },
    {
        "Name": "Fire Baller",
        "Tier": "2",
        "Combined": "Elemental",
        "ID": "BG31_816"
    },
    {
        "Name": "Forest Rover",
        "Tier": "2",
        "Combined": "Beast, Battlecry, Deathrattle",
        "ID": "BG31_801"
    },
    {
        "Name": "Friendly Saloonkeeper",
        "Tier": "2",
        "Combined": "Battlecry",
        "ID": "BGDUO_104"
    },
    {
        "Name": "Gathering Stormer",
        "Tier": "2",
        "Combined": "Elemental",
        "ID": "BGDUO31_201"
    },
    {
        "Name": "Generous Geomancer",
        "Tier": "2",
        "Combined": "Quilboar, Deathrattle",
        "ID": "BGDUO_111"
    },
    {
        "Name": "Green Volumizer",
        "Tier": "2",
        "Combined": "Mech",
        "ID": "BG34_170t3"
    },
    {
        "Name": "Humming Bird",
        "Tier": "2",
        "Combined": "Beast",
        "ID": "BG26_805"
    },
    {
        "Name": "Intrepid Botanist",
        "Tier": "2",
        "Combined": "",
        "ID": "BG32_237"
    },
    {
        "Name": "Laboratory Assistant",
        "Tier": "2",
        "Combined": "Demon, Battlecry",
        "ID": "BG35_150"
    },
    {
        "Name": "Lava Lurker",
        "Tier": "2",
        "Combined": "Naga",
        "ID": "BG23_009"
    },
    {
        "Name": "Lurking Lionfish",
        "Tier": "2",
        "Combined": "Beast",
        "ID": "BG36_201"
    },
    {
        "Name": "Mechagnome Interpreter",
        "Tier": "2",
        "Combined": "Mech",
        "ID": "BG31_177"
    },
    {
        "Name": "Mind Muck",
        "Tier": "2",
        "Combined": "Demon, Battlecry",
        "ID": "BG23_357"
    },
    {
        "Name": "Nerubian Deathswarmer",
        "Tier": "2",
        "Combined": "Undead, Battlecry",
        "ID": "BG25_011"
    },
    {
        "Name": "Patient Scout",
        "Tier": "2",
        "Combined": "Discover",
        "ID": "BG24_715"
    },
    {
        "Name": "Prodigious Tusker",
        "Tier": "2",
        "Combined": "Quilboar",
        "ID": "BG33_430"
    },
    {
        "Name": "Red Volumizer",
        "Tier": "2",
        "Combined": "Mech",
        "ID": "BG34_170t"
    },
    {
        "Name": "Roadboar",
        "Tier": "2",
        "Combined": "Quilboar",
        "ID": "BG20_101"
    },
    {
        "Name": "Scarlet Skull",
        "Tier": "2",
        "Combined": "Undead, Deathrattle, Reborn",
        "ID": "BG25_022"
    },
    {
        "Name": "Sellemental",
        "Tier": "2",
        "Combined": "Elemental",
        "ID": "BGS_115"
    },
    {
        "Name": "Shell Collector",
        "Tier": "2",
        "Combined": "Naga, Battlecry",
        "ID": "BG23_002"
    },
    {
        "Name": "Snow Baller",
        "Tier": "2",
        "Combined": "Elemental",
        "ID": "BG31_818"
    },
    {
        "Name": "Soul Rewinder",
        "Tier": "2",
        "Combined": "Demon",
        "ID": "BG26_174"
    },
    {
        "Name": "Surfing Sylvar",
        "Tier": "2",
        "Combined": "Pirate",
        "ID": "BG32_235"
    },
    {
        "Name": "Tad",
        "Tier": "2",
        "Combined": "Murloc",
        "ID": "BG22_202"
    },
    {
        "Name": "Tarecgosa",
        "Tier": "2",
        "Combined": "Dragon",
        "ID": "BG21_015"
    },
    {
        "Name": "Thaumaturgist",
        "Tier": "2",
        "Combined": "Naga",
        "ID": "BG31_924"
    },
    {
        "Name": "Underrot Spawn",
        "Tier": "2",
        "Combined": "Taunt, Deathrattle",
        "ID": "BG36_116"
    },
    {
        "Name": "Very Hungry Winterfinner",
        "Tier": "2",
        "Combined": "Murloc, Taunt",
        "ID": "BG29_300"
    },
    {
        "Name": "Wanderer Cho",
        "Tier": "2",
        "Combined": "",
        "ID": "BGDUO_100"
    },
    {
        "Name": "Wandering Willbreaker",
        "Tier": "2",
        "Combined": "",
        "ID": "BG36_100"
    },
    {
        "Name": "Abyssal Envoy",
        "Tier": "3",
        "Combined": "",
        "ID": "BG36_311"
    },
    {
        "Name": "Accord-o-Tron",
        "Tier": "3",
        "Combined": "Mech",
        "ID": "BG26_147"
    },
    {
        "Name": "Amber Guardian",
        "Tier": "3",
        "Combined": "Dragon, Taunt, Divine Shield",
        "ID": "BG24_500"
    },
    {
        "Name": "Annoy-o-Module",
        "Tier": "3",
        "Combined": "Mech, Divine Shield, Taunt",
        "ID": "BG_BOT_911"
    },
    {
        "Name": "Auto Accelerator",
        "Tier": "3",
        "Combined": "Mech, Battlecry",
        "ID": "BG34_170"
    },
    {
        "Name": "Azsharan Cutlassier",
        "Tier": "3",
        "Combined": "Pirate, Battlecry",
        "ID": "BG33_830"
    },
    {
        "Name": "Blue Whelp",
        "Tier": "3",
        "Combined": "Dragon",
        "ID": "BG33_924"
    },
    {
        "Name": "Bottom Feeder",
        "Tier": "3",
        "Combined": "Murloc",
        "ID": "BGDUO33_140"
    },
    {
        "Name": "Cadaver Caretaker",
        "Tier": "3",
        "Combined": "Undead, Deathrattle",
        "ID": "BG30_125"
    },
    {
        "Name": "Deadly Spore",
        "Tier": "3",
        "Combined": "Venomous",
        "ID": "BGS_131"
    },
    {
        "Name": "Deep-Sea Angler",
        "Tier": "3",
        "Combined": "Naga, Taunt",
        "ID": "BG23_004"
    },
    {
        "Name": "Devout Hellcaller",
        "Tier": "3",
        "Combined": "Demon",
        "ID": "BG33_155"
    },
    {
        "Name": "Diremuck Forager",
        "Tier": "3",
        "Combined": "Murloc",
        "ID": "BG27_556"
    },
    {
        "Name": "Disguised Graverobber",
        "Tier": "3",
        "Combined": "Undead, Battlecry",
        "ID": "BG28_303"
    },
    {
        "Name": "Doting Dracthyr",
        "Tier": "3",
        "Combined": "Dragon",
        "ID": "BGDUO_107"
    },
    {
        "Name": "Drifting Sacrifice",
        "Tier": "3",
        "Combined": "Deathrattle, Reborn",
        "ID": "BG36_113"
    },
    {
        "Name": "Fearless Foodie",
        "Tier": "3",
        "Combined": "Quilboar",
        "ID": "BG30_123"
    },
    {
        "Name": "Fetid Corroder",
        "Tier": "3",
        "Combined": "Battlecry",
        "ID": "BG36_112"
    },
    {
        "Name": "Fruit Vendor",
        "Tier": "3",
        "Combined": "",
        "ID": "BG36_346"
    },
    {
        "Name": "Gem Rat",
        "Tier": "3",
        "Combined": "Quilboar",
        "ID": "BG31_326"
    },
    {
        "Name": "Greedy Conniver",
        "Tier": "3",
        "Combined": "Pirate, Discover",
        "ID": "BG36_369"
    },
    {
        "Name": "Handless Forsaken",
        "Tier": "3",
        "Combined": "Undead, Deathrattle",
        "ID": "BG25_010"
    },
    {
        "Name": "Hired Mount",
        "Tier": "3",
        "Combined": "Dragon",
        "ID": "BG36_240"
    },
    {
        "Name": "Iron Groundskeeper",
        "Tier": "3",
        "Combined": "Battlecry, Taunt",
        "ID": "BG27_000"
    },
    {
        "Name": "Jumping Jack",
        "Tier": "3",
        "Combined": "Beast, Demon, Dragon, Elemental, Mech, Murloc, Naga, Pirate, Quilboar, Undead",
        "ID": "BGDUO_115"
    },
    {
        "Name": "Locked-up Mutineer",
        "Tier": "3",
        "Combined": "Pirate, Deathrattle",
        "ID": "BG36_521"
    },
    {
        "Name": "Malchezaar, Prince of Dance",
        "Tier": "3",
        "Combined": "Demon",
        "ID": "BG26_524"
    },
    {
        "Name": "Mangled Bandit",
        "Tier": "3",
        "Combined": "Quilboar",
        "ID": "BG28_582"
    },
    {
        "Name": "Mummifier",
        "Tier": "3",
        "Combined": "Undead, Deathrattle",
        "ID": "BG28_309"
    },
    {
        "Name": "Orc-estra Conductor",
        "Tier": "3",
        "Combined": "Battlecry",
        "ID": "BGDUO_119"
    },
    {
        "Name": "Plunder Pal",
        "Tier": "3",
        "Combined": "Pirate",
        "ID": "BGDUO_118"
    },
    {
        "Name": "Prosthetic Hand",
        "Tier": "3",
        "Combined": "Mech, Reborn, Undead",
        "ID": "BG_DEEP_015"
    },
    {
        "Name": "Puddle Prancer",
        "Tier": "3",
        "Combined": "Murloc",
        "ID": "BGDUO_117"
    },
    {
        "Name": "Relentless Deflector",
        "Tier": "3",
        "Combined": "Mech, Aura, Avenge, Divine Shield, Taunt",
        "ID": "BG34_405"
    },
    {
        "Name": "Rescue Bot",
        "Tier": "3",
        "Combined": "Mech, Deathrattle, Taunt",
        "ID": "BG36_854"
    },
    {
        "Name": "Roaring Recruiter",
        "Tier": "3",
        "Combined": "Dragon",
        "ID": "BG29_816"
    },
    {
        "Name": "Shoalfin Mystic",
        "Tier": "3",
        "Combined": "Murloc",
        "ID": "BG32_860"
    },
    {
        "Name": "Sly Infiltrator",
        "Tier": "3",
        "Combined": "Quilboar",
        "ID": "BG36_330"
    },
    {
        "Name": "Sprightly Scarab",
        "Tier": "3",
        "Combined": "Beast, Windfury",
        "ID": "BG27_084"
    },
    {
        "Name": "Tasty Lobster",
        "Tier": "3",
        "Combined": "Beast, Deathrattle",
        "ID": "BG36_202"
    },
    {
        "Name": "Thorned Trailblazer",
        "Tier": "3",
        "Combined": "Quilboar",
        "ID": "BG31_327"
    },
    {
        "Name": "Timecap'n Hooktail",
        "Tier": "3",
        "Combined": "Pirate, Dragon",
        "ID": "BG27_005"
    },
    {
        "Name": "Trapped Clapper",
        "Tier": "3",
        "Combined": "Demon, Deathrattle",
        "ID": "BG36_730"
    },
    {
        "Name": "Treasure Parrot",
        "Tier": "3",
        "Combined": "Pirate, Beast",
        "ID": "BG36_763"
    },
    {
        "Name": "Trench Fighter",
        "Tier": "3",
        "Combined": "Quilboar",
        "ID": "BG34_684"
    },
    {
        "Name": "Unwilling Slacker",
        "Tier": "3",
        "Combined": "Deathrattle",
        "ID": "BG36_101"
    },
    {
        "Name": "Vicious Mindslasher",
        "Tier": "3",
        "Combined": "",
        "ID": "BG36_108"
    },
    {
        "Name": "Voidpriest Cloner",
        "Tier": "3",
        "Combined": "",
        "ID": "BGDUO_700"
    },
    {
        "Name": "Waveling",
        "Tier": "3",
        "Combined": "Elemental, Deathrattle",
        "ID": "BG34_856"
    },
    {
        "Name": "Waverider",
        "Tier": "3",
        "Combined": "Naga, Windfury",
        "ID": "BG23_007"
    },
    {
        "Name": "Wheeled Crewmate",
        "Tier": "3",
        "Combined": "Pirate, Deathrattle",
        "ID": "BGDUO31_207"
    },
    {
        "Name": "Wildfire Elemental",
        "Tier": "3",
        "Combined": "Elemental",
        "ID": "BGS_126"
    },
    {
        "Name": "Wolf Pup",
        "Tier": "3",
        "Combined": "Beast",
        "ID": "BG36_207"
    },
    {
        "Name": "Abyssal Bruiser",
        "Tier": "4",
        "Combined": "Naga, Aura, Divine Shield",
        "ID": "BG35_921"
    },
    {
        "Name": "Air Baller",
        "Tier": "4",
        "Combined": "Elemental",
        "ID": "BG36_181"
    },
    {
        "Name": "Ashen Corruptor",
        "Tier": "4",
        "Combined": "Demon",
        "ID": "BG32_873"
    },
    {
        "Name": "Banana Slamma",
        "Tier": "4",
        "Combined": "Beast",
        "ID": "BG26_802"
    },
    {
        "Name": "Bigwig Bandit",
        "Tier": "4",
        "Combined": "Pirate",
        "ID": "BG33_822"
    },
    {
        "Name": "Blade Collector",
        "Tier": "4",
        "Combined": "Pirate",
        "ID": "BG26_817"
    },
    {
        "Name": "Bonker",
        "Tier": "4",
        "Combined": "Quilboar, Windfury",
        "ID": "BG20_104"
    },
    {
        "Name": "Boom-in-a-Box",
        "Tier": "4",
        "Combined": "Taunt",
        "ID": "BG36_620"
    },
    {
        "Name": "Bramble Tunneler",
        "Tier": "4",
        "Combined": "Quilboar",
        "ID": "BG36_331"
    },
    {
        "Name": "Bream Counter",
        "Tier": "4",
        "Combined": "Murloc",
        "ID": "BG26_137"
    },
    {
        "Name": "Bronze Timewalker",
        "Tier": "4",
        "Combined": "Dragon",
        "ID": "BG36_242"
    },
    {
        "Name": "Cage Gnawer",
        "Tier": "4",
        "Combined": "Beast",
        "ID": "BG36_211"
    },
    {
        "Name": "Cagey Conjurer",
        "Tier": "4",
        "Combined": "Naga",
        "ID": "BG36_508"
    },
    {
        "Name": "Conveyor Construct",
        "Tier": "4",
        "Combined": "Mech, Deathrattle",
        "ID": "BG34_171"
    },
    {
        "Name": "Cutthroat K'Thir",
        "Tier": "4",
        "Combined": "",
        "ID": "BG36_106"
    },
    {
        "Name": "Dead Bellringer",
        "Tier": "4",
        "Combined": "Undead",
        "ID": "BG36_511"
    },
    {
        "Name": "Drone Duplicator",
        "Tier": "4",
        "Combined": "Mech, Divine Shield",
        "ID": "BG36_506"
    },
    {
        "Name": "En-Djinn Blazer",
        "Tier": "4",
        "Combined": "Elemental, Battlecry",
        "ID": "BG34_865"
    },
    {
        "Name": "Enchanted Sentinel",
        "Tier": "4",
        "Combined": "Mech, Aura",
        "ID": "BG35_341"
    },
    {
        "Name": "Faceless Operative",
        "Tier": "4",
        "Combined": "",
        "ID": "BG36_308"
    },
    {
        "Name": "Feisty Freshwater",
        "Tier": "4",
        "Combined": "Elemental, Deathrattle",
        "ID": "BGDUO_110"
    },
    {
        "Name": "Flaming Enforcer",
        "Tier": "4",
        "Combined": "Demon, Elemental",
        "ID": "BG34_500"
    },
    {
        "Name": "Friendly Geist",
        "Tier": "4",
        "Combined": "Undead, Deathrattle",
        "ID": "BG32_880"
    },
    {
        "Name": "Gearfin",
        "Tier": "4",
        "Combined": "Murloc, Mech",
        "ID": "BG36_764"
    },
    {
        "Name": "Geomagus Roogug",
        "Tier": "4",
        "Combined": "Quilboar, Divine Shield",
        "ID": "BG28_583"
    },
    {
        "Name": "Glambot",
        "Tier": "4",
        "Combined": "Mech",
        "ID": "BG36_853"
    },
    {
        "Name": "Gormling Gourmet",
        "Tier": "4",
        "Combined": "Murloc, Battlecry, Deathrattle, Taunt",
        "ID": "BG32_336"
    },
    {
        "Name": "Grave Narrator",
        "Tier": "4",
        "Combined": "Undead, Avenge",
        "ID": "BGDUO_112"
    },
    {
        "Name": "Gunpowder Courier",
        "Tier": "4",
        "Combined": "Pirate",
        "ID": "BG26_810"
    },
    {
        "Name": "Headhunter Gryphon",
        "Tier": "4",
        "Combined": "Beast",
        "ID": "BG36_204"
    },
    {
        "Name": "Heroic Underdog",
        "Tier": "4",
        "Combined": "",
        "ID": "BG34_604"
    },
    {
        "Name": "Hoarding Hyena",
        "Tier": "4",
        "Combined": "Beast",
        "ID": "BG36_210"
    },
    {
        "Name": "Holy Vanguard",
        "Tier": "4",
        "Combined": "Divine Shield",
        "ID": "BG36_372"
    },
    {
        "Name": "Hot-Air Surveyor",
        "Tier": "4",
        "Combined": "Quilboar, Aura",
        "ID": "BG30_121"
    },
    {
        "Name": "Humon'gozz",
        "Tier": "4",
        "Combined": "Aura, Divine Shield",
        "ID": "BG32_341"
    },
    {
        "Name": "Ichoron the Protector",
        "Tier": "4",
        "Combined": "Elemental, Divine Shield",
        "ID": "BG31_812"
    },
    {
        "Name": "Imp-lusionist",
        "Tier": "4",
        "Combined": "Demon, Deathrattle",
        "ID": "BG36_731"
    },
    {
        "Name": "Imposing Percussionist",
        "Tier": "4",
        "Combined": "Demon, Battlecry, Discover",
        "ID": "BG26_525"
    },
    {
        "Name": "Kelp Keeper",
        "Tier": "4",
        "Combined": "Murloc, Battlecry",
        "ID": "BG36_701"
    },
    {
        "Name": "Leyline Surfacer",
        "Tier": "4",
        "Combined": "Elemental, Battlecry, Deathrattle",
        "ID": "BG35_881"
    },
    {
        "Name": "Living Prison",
        "Tier": "4",
        "Combined": "Elemental",
        "ID": "BG36_180"
    },
    {
        "Name": "Lovesick Balladist",
        "Tier": "4",
        "Combined": "Pirate, Battlecry",
        "ID": "BG26_814"
    },
    {
        "Name": "Mantid King",
        "Tier": "4",
        "Combined": "Taunt, Divine Shield, Venomous",
        "ID": "BGDUO31_212"
    },
    {
        "Name": "Maritime Extortionist",
        "Tier": "4",
        "Combined": "Pirate, Aura",
        "ID": "BG36_524"
    },
    {
        "Name": "Maw Caster",
        "Tier": "4",
        "Combined": "Undead, Battlecry, Discover",
        "ID": "BG32_340"
    },
    {
        "Name": "Mindbending Recruiter",
        "Tier": "4",
        "Combined": "",
        "ID": "BG36_312"
    },
    {
        "Name": "Mirror Monster",
        "Tier": "4",
        "Combined": "Beast, Demon, Dragon, Elemental, Mech, Murloc, Naga, Pirate, Quilboar, Undead, Discover",
        "ID": "BGDUO_108"
    },
    {
        "Name": "Nightmare Corroder",
        "Tier": "4",
        "Combined": "",
        "ID": "BG36_115"
    },
    {
        "Name": "Parasitic Fleshling",
        "Tier": "4",
        "Combined": "",
        "ID": "BG36_114"
    },
    {
        "Name": "Persistent Poet",
        "Tier": "4",
        "Combined": "Dragon, Divine Shield",
        "ID": "BG29_813"
    },
    {
        "Name": "Plaguerunner",
        "Tier": "4",
        "Combined": "Undead, Deathrattle",
        "ID": "BG34_690"
    },
    {
        "Name": "Private Chef",
        "Tier": "4",
        "Combined": "Naga",
        "ID": "BGDUO31_209"
    },
    {
        "Name": "Razorfen Flapper",
        "Tier": "4",
        "Combined": "Quilboar, Battlecry, Deathrattle",
        "ID": "BG34_682"
    },
    {
        "Name": "Refreshing Anomaly",
        "Tier": "4",
        "Combined": "Elemental, Battlecry",
        "ID": "BGS_116"
    },
    {
        "Name": "Rimescale Priestess",
        "Tier": "4",
        "Combined": "Naga",
        "ID": "BG33_319"
    },
    {
        "Name": "Runic Arcanist",
        "Tier": "4",
        "Combined": "Dragon",
        "ID": "BG36_245"
    },
    {
        "Name": "Sacrificial Wrathguard",
        "Tier": "4",
        "Combined": "Demon, Deathrattle",
        "ID": "BG36_362"
    },
    {
        "Name": "San'layn Scribe",
        "Tier": "4",
        "Combined": "Undead, Aura",
        "ID": "BGDUO31_208"
    },
    {
        "Name": "Seafloor Recruiter",
        "Tier": "4",
        "Combined": "Naga",
        "ID": "BG34_925"
    },
    {
        "Name": "Shifty Snake",
        "Tier": "4",
        "Combined": "Beast, Deathrattle",
        "ID": "BGDUO31_203"
    },
    {
        "Name": "Sin'dorei Straight Shot",
        "Tier": "4",
        "Combined": "Taunt, Divine Shield, Windfury",
        "ID": "BG25_016"
    },
    {
        "Name": "Sky-hatch Runaway",
        "Tier": "4",
        "Combined": "Dragon",
        "ID": "BG36_243"
    },
    {
        "Name": "Snare Trapper",
        "Tier": "4",
        "Combined": "Quilboar",
        "ID": "BG36_332"
    },
    {
        "Name": "Snarky Shark",
        "Tier": "4",
        "Combined": "Beast",
        "ID": "BG36_206"
    },
    {
        "Name": "Soulkeeping Jailer",
        "Tier": "4",
        "Combined": "Demon",
        "ID": "BG36_503"
    },
    {
        "Name": "Tavern Tempest",
        "Tier": "4",
        "Combined": "Elemental, Battlecry",
        "ID": "BGS_123"
    },
    {
        "Name": "Tortollan Blue Shell",
        "Tier": "4",
        "Combined": "",
        "ID": "BG24_018"
    },
    {
        "Name": "Twilight Tidehunter",
        "Tier": "4",
        "Combined": "Murloc",
        "ID": "BG36_703"
    },
    {
        "Name": "Zesty Shaker",
        "Tier": "4",
        "Combined": "Naga",
        "ID": "BG26_505"
    },
    {
        "Name": "Air Revenant",
        "Tier": "5",
        "Combined": "Elemental",
        "ID": "BG34_858"
    },
    {
        "Name": "Barrier Banshee",
        "Tier": "5",
        "Combined": "Undead, Divine Shield",
        "ID": "BG36_514"
    },
    {
        "Name": "Bile Spitter",
        "Tier": "5",
        "Combined": "Murloc, Venomous",
        "ID": "BG33_318"
    },
    {
        "Name": "Brann Bronzebeard",
        "Tier": "5",
        "Combined": "Aura, Battlecry",
        "ID": "BG_LOE_077"
    },
    {
        "Name": "C'Thrax Wrecker",
        "Tier": "5",
        "Combined": "Battlecry, Deathrattle",
        "ID": "BGDUO_701"
    },
    {
        "Name": "Cataclysmic Harbinger",
        "Tier": "5",
        "Combined": "",
        "ID": "BG35_123"
    },
    {
        "Name": "Charging Czarina",
        "Tier": "5",
        "Combined": "Mech, Divine Shield",
        "ID": "BG28_741"
    },
    {
        "Name": "Costume Enthusiast",
        "Tier": "5",
        "Combined": "Murloc, Divine Shield",
        "ID": "BG34_142"
    },
    {
        "Name": "Darkcrest Strategist",
        "Tier": "5",
        "Combined": "Naga",
        "ID": "BG31_920"
    },
    {
        "Name": "De-volition-ist",
        "Tier": "5",
        "Combined": "",
        "ID": "BG36_102"
    },
    {
        "Name": "Deft Deserter",
        "Tier": "5",
        "Combined": "Demon, Divine Shield, Taunt, Windfury",
        "ID": "BG36_621"
    },
    {
        "Name": "Devilish Distractor",
        "Tier": "5",
        "Combined": "Demon",
        "ID": "BG36_762"
    },
    {
        "Name": "Draconic Warden",
        "Tier": "5",
        "Combined": "Dragon, Battlecry, Deathrattle",
        "ID": "BG34_633"
    },
    {
        "Name": "Drakkari Enchanter",
        "Tier": "5",
        "Combined": "Aura",
        "ID": "BG26_ICC_901"
    },
    {
        "Name": "Drustfallen Butcher",
        "Tier": "5",
        "Combined": "Undead, Avenge",
        "ID": "BG32_324"
    },
    {
        "Name": "Elite Navigator",
        "Tier": "5",
        "Combined": "Pirate, Battlecry",
        "ID": "BG32_231"
    },
    {
        "Name": "Enterprising Escapee",
        "Tier": "5",
        "Combined": "Pirate",
        "ID": "BG36_523"
    },
    {
        "Name": "Eternal Summoner",
        "Tier": "5",
        "Combined": "Undead, Deathrattle, Reborn",
        "ID": "BG25_009"
    },
    {
        "Name": "Eternal Tycoon",
        "Tier": "5",
        "Combined": "Undead, Avenge",
        "ID": "BG34_403"
    },
    {
        "Name": "Faceless Converter",
        "Tier": "5",
        "Combined": "Deathrattle",
        "ID": "BG36_318"
    },
    {
        "Name": "Felboar",
        "Tier": "5",
        "Combined": "Quilboar, Demon",
        "ID": "BG28_633"
    },
    {
        "Name": "Felfire Conjurer",
        "Tier": "5",
        "Combined": "Dragon, Demon",
        "ID": "BG32_821"
    },
    {
        "Name": "Firelands Fugitive",
        "Tier": "5",
        "Combined": "Elemental, Battlecry",
        "ID": "BG35_882"
    },
    {
        "Name": "Firescale Hoarder",
        "Tier": "5",
        "Combined": "Dragon, Battlecry, Deathrattle, Naga",
        "ID": "BG32_820"
    },
    {
        "Name": "Ghastcoiler",
        "Tier": "5",
        "Combined": "Beast, Deathrattle",
        "ID": "BGS_008"
    },
    {
        "Name": "Glowscale",
        "Tier": "5",
        "Combined": "Naga, Taunt, Divine Shield",
        "ID": "BG23_008"
    },
    {
        "Name": "Goldrinn, the Great Wolf",
        "Tier": "5",
        "Combined": "Beast, Deathrattle",
        "ID": "BGS_018"
    },
    {
        "Name": "Hackerfin",
        "Tier": "5",
        "Combined": "Murloc, Battlecry",
        "ID": "BG31_148"
    },
    {
        "Name": "Hopebringer",
        "Tier": "5",
        "Combined": "Dragon, Divine Shield",
        "ID": "BG36_364"
    },
    {
        "Name": "Insatiable Ur'zul",
        "Tier": "5",
        "Combined": "Demon, Taunt",
        "ID": "BG21_004"
    },
    {
        "Name": "Kalecgos, Arcane Aspect",
        "Tier": "5",
        "Combined": "Dragon, Battlecry",
        "ID": "BGS_041"
    },
    {
        "Name": "Leeroy the Reckless",
        "Tier": "5",
        "Combined": "Deathrattle",
        "ID": "BG23_318"
    },
    {
        "Name": "Lichling Hoarder",
        "Tier": "5",
        "Combined": "Undead, Avenge",
        "ID": "BG36_848"
    },
    {
        "Name": "Living Azerite",
        "Tier": "5",
        "Combined": "Elemental",
        "ID": "BG28_707"
    },
    {
        "Name": "Lurking Leviathan",
        "Tier": "5",
        "Combined": "Beast",
        "ID": "BG35_602"
    },
    {
        "Name": "Man'ari Messenger",
        "Tier": "5",
        "Combined": "Demon, Battlecry",
        "ID": "BGDUO_121"
    },
    {
        "Name": "Mindbender Ghur'sha",
        "Tier": "5",
        "Combined": "",
        "ID": "BG36_097"
    },
    {
        "Name": "Mysterious K'Thir",
        "Tier": "5",
        "Combined": "",
        "ID": "BG36_320"
    },
    {
        "Name": "N'raqi Frostcaller",
        "Tier": "5",
        "Combined": "",
        "ID": "BG36_300"
    },
    {
        "Name": "N'raqi Sapper",
        "Tier": "5",
        "Combined": "Battlecry, Deathrattle",
        "ID": "BG36_103"
    },
    {
        "Name": "Nightmare Par-tea Guest",
        "Tier": "5",
        "Combined": "Beast, Demon, Dragon, Elemental, Mech, Murloc, Naga, Pirate, Quilboar, Undead, Battlecry, Deathrattle",
        "ID": "BG32_111"
    },
    {
        "Name": "Primalfin Lookout",
        "Tier": "5",
        "Combined": "Murloc, Battlecry, Discover",
        "ID": "BGS_020"
    },
    {
        "Name": "Proud Privateer",
        "Tier": "5",
        "Combined": "Pirate, Aura",
        "ID": "BG33_825"
    },
    {
        "Name": "Razorfen Vineweaver",
        "Tier": "5",
        "Combined": "Quilboar",
        "ID": "BG33_883"
    },
    {
        "Name": "Resourceful Robot",
        "Tier": "5",
        "Combined": "Mech",
        "ID": "BG36_366"
    },
    {
        "Name": "Rodeo Performer",
        "Tier": "5",
        "Combined": "Battlecry, Discover",
        "ID": "BG28_550"
    },
    {
        "Name": "Sanguine Refiner",
        "Tier": "5",
        "Combined": "Quilboar",
        "ID": "BG33_885"
    },
    {
        "Name": "Selfless Sightseer",
        "Tier": "5",
        "Combined": "Dragon, Battlecry",
        "ID": "BGDUO31_205"
    },
    {
        "Name": "Sewer Escapee",
        "Tier": "5",
        "Combined": "Murloc",
        "ID": "BG36_700"
    },
    {
        "Name": "Sewer Lord",
        "Tier": "5",
        "Combined": "Beast, Deathrattle, Taunt",
        "ID": "BG35_604"
    },
    {
        "Name": "Shamanic Tidecaller",
        "Tier": "5",
        "Combined": "Murloc",
        "ID": "BG36_704"
    },
    {
        "Name": "Ship Master Eudora",
        "Tier": "5",
        "Combined": "Pirate, Deathrattle",
        "ID": "BG33_828"
    },
    {
        "Name": "Shipwrecked Rascal",
        "Tier": "5",
        "Combined": "Pirate, Battlecry, Deathrattle",
        "ID": "BG33_821"
    },
    {
        "Name": "Showy Cyclist",
        "Tier": "5",
        "Combined": "Naga, Deathrattle",
        "ID": "BG31_925"
    },
    {
        "Name": "Spark Snapper",
        "Tier": "5",
        "Combined": "Mech",
        "ID": "BG36_851"
    },
    {
        "Name": "Storm Splitter",
        "Tier": "5",
        "Combined": "Naga",
        "ID": "BGDUO_122"
    },
    {
        "Name": "Support System",
        "Tier": "5",
        "Combined": "Mech, Divine Shield",
        "ID": "BGDUO_109"
    },
    {
        "Name": "Tichondrius",
        "Tier": "5",
        "Combined": "Demon",
        "ID": "BG26_523"
    },
    {
        "Name": "Titus Rivendare",
        "Tier": "5",
        "Combined": "Aura, Deathrattle",
        "ID": "BG25_354"
    },
    {
        "Name": "Tranquil Meditative",
        "Tier": "5",
        "Combined": "Naga",
        "ID": "BG32_835"
    },
    {
        "Name": "Turquoise Skitterer",
        "Tier": "5",
        "Combined": "Beast, Deathrattle",
        "ID": "BG31_809"
    },
    {
        "Name": "Well Wisher",
        "Tier": "5",
        "Combined": "",
        "ID": "BGDUO_120"
    },
    {
        "Name": "Auto Reveille",
        "Tier": "6",
        "Combined": "Mech",
        "ID": "BG36_367"
    },
    {
        "Name": "Balinda Stonehearth",
        "Tier": "6",
        "Combined": "Aura",
        "ID": "BG35_883"
    },
    {
        "Name": "Choral Mrrrglr",
        "Tier": "6",
        "Combined": "Murloc",
        "ID": "BG26_354"
    },
    {
        "Name": "Crimson Vindicator",
        "Tier": "6",
        "Combined": "Dragon, Divine Shield",
        "ID": "BG36_241"
    },
    {
        "Name": "Dark Dazzler",
        "Tier": "6",
        "Combined": "Demon",
        "ID": "BGDUO33_150"
    },
    {
        "Name": "Dark Puppeteer",
        "Tier": "6",
        "Combined": "Deathrattle",
        "ID": "BG36_104"
    },
    {
        "Name": "Deathly Striker",
        "Tier": "6",
        "Combined": "Undead, Avenge, Deathrattle",
        "ID": "BG31_835"
    },
    {
        "Name": "Deathstrider",
        "Tier": "6",
        "Combined": "Beast, Deathrattle",
        "ID": "BG36_208"
    },
    {
        "Name": "Elemental of Surprise",
        "Tier": "6",
        "Combined": "Elemental, Divine Shield",
        "ID": "BG26_175"
    },
    {
        "Name": "Eredar Escapist",
        "Tier": "6",
        "Combined": "Demon",
        "ID": "BG36_733"
    },
    {
        "Name": "Falling Sky Golem",
        "Tier": "6",
        "Combined": "Mech, Aura, Divine Shield, Deathrattle",
        "ID": "BG35_342"
    },
    {
        "Name": "Fauna Whisperer",
        "Tier": "6",
        "Combined": "Naga",
        "ID": "BG32_837"
    },
    {
        "Name": "Forsaken Weaver",
        "Tier": "6",
        "Combined": "Undead",
        "ID": "BG34_692"
    },
    {
        "Name": "Gatekeeper Amalgam",
        "Tier": "6",
        "Combined": "Beast, Demon, Dragon, Elemental, Mech, Murloc, Naga, Pirate, Quilboar, Undead",
        "ID": "BG36_640"
    },
    {
        "Name": "Groundbreaker",
        "Tier": "6",
        "Combined": "Naga",
        "ID": "BG31_035"
    },
    {
        "Name": "Harbinger Aph'lass",
        "Tier": "6",
        "Combined": "",
        "ID": "BGFYM_005"
    },
    {
        "Name": "Heroic Broodmother",
        "Tier": "6",
        "Combined": "Dragon, Divine Shield",
        "ID": "BG36_849"
    },
    {
        "Name": "Hooktusk, Master Marauder",
        "Tier": "6",
        "Combined": "Pirate, Discover",
        "ID": "BG36_344"
    },
    {
        "Name": "Loyal Mobster",
        "Tier": "6",
        "Combined": "Quilboar",
        "ID": "BGDUO31_202"
    },
    {
        "Name": "Magicfin Mycologist",
        "Tier": "6",
        "Combined": "Murloc",
        "ID": "BG33_891"
    },
    {
        "Name": "Nadina the Red",
        "Tier": "6",
        "Combined": "Dragon, Deathrattle, Divine Shield",
        "ID": "BGS_040"
    },
    {
        "Name": "Ravaging Scorpid",
        "Tier": "6",
        "Combined": "Beast, Deathrattle",
        "ID": "BG36_209"
    },
    {
        "Name": "Sanguine Champion",
        "Tier": "6",
        "Combined": "Quilboar, Battlecry, Deathrattle",
        "ID": "BG23_017"
    },
    {
        "Name": "Silent Deliverer",
        "Tier": "6",
        "Combined": "Pirate, Battlecry",
        "ID": "BG36_343"
    },
    {
        "Name": "Sky Admiral Rogers",
        "Tier": "6",
        "Combined": "Pirate",
        "ID": "BG33_823"
    },
    {
        "Name": "Snazzy Phantom",
        "Tier": "6",
        "Combined": "Undead",
        "ID": "BG36_515"
    },
    {
        "Name": "The Shadow of Doubt",
        "Tier": "6",
        "Combined": "",
        "ID": "BG36_109"
    },
    {
        "Name": "Torrential Ruiner",
        "Tier": "6",
        "Combined": "Naga",
        "ID": "BG36_622"
    },
    {
        "Name": "Transport Reactor",
        "Tier": "6",
        "Combined": "Mech, Aura",
        "ID": "BGDUO31_211"
    },
    {
        "Name": "Turbo Hogrider",
        "Tier": "6",
        "Combined": "Quilboar",
        "ID": "BG31_323"
    },
    {
        "Name": "Twisted Wrathguard",
        "Tier": "6",
        "Combined": "Demon",
        "ID": "BG35_155"
    },
    {
        "Name": "Tyrael",
        "Tier": "6",
        "Combined": "",
        "ID": "BG36_356"
    },
    {
        "Name": "Ultraviolet Ascendant",
        "Tier": "6",
        "Combined": "Elemental",
        "ID": "BG31_810"
    },
    {
        "Name": "Unbound Tempest",
        "Tier": "6",
        "Combined": "Elemental",
        "ID": "BG36_352"
    },
    {
        "Name": "Utility Drone",
        "Tier": "6",
        "Combined": "Mech",
        "ID": "BG26_152"
    },
    {
        "Name": "Veteran Brigand",
        "Tier": "6",
        "Combined": "Quilboar",
        "ID": "BG36_341"
    },
    {
        "Name": "Victorious Geomant",
        "Tier": "6",
        "Combined": "Quilboar",
        "ID": "BG36_370"
    },
    {
        "Name": "Young Murk-Eye",
        "Tier": "6",
        "Combined": "Murloc, Battlecry",
        "ID": "BG22_403"
    },
    {
        "Name": "Captain Sanders",
        "Tier": "7",
        "Combined": "Pirate, Battlecry",
        "ID": "BG25_034"
    },
    {
        "Name": "Champion of Sargeras",
        "Tier": "7",
        "Combined": "Demon, Battlecry, Deathrattle",
        "ID": "BG27_016"
    },
    {
        "Name": "Futurefin",
        "Tier": "7",
        "Combined": "Murloc",
        "ID": "BG34_145"
    },
    {
        "Name": "Highkeeper Ra",
        "Tier": "7",
        "Combined": "Battlecry, Deathrattle",
        "ID": "BG34_319"
    },
    {
        "Name": "Jailbird Juggernaut",
        "Tier": "7",
        "Combined": "Quilboar",
        "ID": "BG36_333"
    },
    {
        "Name": "Obsidian Ravager",
        "Tier": "7",
        "Combined": "Dragon",
        "ID": "BG27_017"
    },
    {
        "Name": "Polarizing Beatboxer",
        "Tier": "7",
        "Combined": "Mech",
        "ID": "BG26_149"
    },
    {
        "Name": "Sandy",
        "Tier": "7",
        "Combined": "",
        "ID": "BGDUO_125"
    },
    {
        "Name": "Sea Witch Zar'jira",
        "Tier": "7",
        "Combined": "Naga",
        "ID": "BG27_514"
    },
    {
        "Name": "Sha of Fear",
        "Tier": "7",
        "Combined": "",
        "ID": "BG36_111"
    },
    {
        "Name": "Stalwart Kodo",
        "Tier": "7",
        "Combined": "Beast",
        "ID": "BG34_322"
    },
    {
        "Name": "Stitched Salvager",
        "Tier": "7",
        "Combined": "Undead, Deathrattle",
        "ID": "BG31_999"
    },
    {
        "Name": "Stone Age Slab",
        "Tier": "7",
        "Combined": "Elemental",
        "ID": "BG34_950"
    },
    {
        "Name": "The Last One Standing",
        "Tier": "7",
        "Combined": "Beast, Demon, Dragon, Elemental, Mech, Murloc, Naga, Pirate, Quilboar, Undead",
        "ID": "BG34_320"
    }
]

export default minions;